import React from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./Resources.module.scss";
import ArrowRightAltRounded from "@material-ui/icons/ArrowRightAltRounded";
import MUButton from "@material-ui/core/Button";
import Button from "shared/components/Buttons/Button";

const Resources = () => {
  return (
    <div className={styles.resources}>
      <h1>About</h1>

      <p>
        Devchallenges is designed for everyone who wants to be a software
        developer, it consists of different projects or you might call it
        challenges.
      </p>

      <p>
        Each challenge is different and will test you different aspects of
        coding. It includes small user stories and beautiful designs. It
        reflects real-life tasks that a developer does daily.
      </p>

      <p>
        You can also find different paths that will help you navigate your
        career path.
      </p>

      <div className={styles.resources_tips}>
        <h5 className={styles.resources_notice}>Notes:</h5>
        <p>
          DevChallenges is an amazing collection of software engineering
          projects with amazing designs, but to get the most out of it, you need
          to know the basics of web development.
        </p>

        <p>
          If you do not know where to start, check out DevChallenges articles
          and videos.
        </p>

        <p>
          If you already know what to study, check out{" "}
          <a href="#recommened-resources">recommended resources</a>.
        </p>
      </div>

      <div className={styles.resources_devChallengesPanel}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={7}>
            <h3>Articles</h3>
            <p>
              You will find useful tips, tutorials, motivations,.. to help you
              get the best of<i>DevChallenges</i>.
            </p>

            <p>
              You can also request to have your blog published here (coming
              soon)
            </p>

            <div className={styles.resources_devChallengesPanel_button}>
              <MUButton
                onClick={() => {
                  window.location.href = "https://devchallenges-blogs.web.app/";
                }}
                variant="text"
                type="button"
                style={{
                  textTransform: "lowercase",
                  fontFamily: "var(--heading-font-family)",
                  color: "var(--blue)",
                  fontSize: "var(--text-sm)",
                }}
                size="small"
                endIcon={<ArrowRightAltRounded />}
              >
                check it out
              </MUButton>
            </div>
          </Grid>

          <Grid item xs={12} sm={5}>
            <img
              loading="lazy"
              alt="Articles"
              className={styles.resources_img}
              src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80"
            ></img>
          </Grid>
        </Grid>
      </div>

      <div className={styles.resources_devChallengesPanel}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={7}>
            <h3>Videos</h3>
            <p>
              You will find here different videos. For instance, tutorials on
              how to start with <i>DevChallenges</i>.
            </p>

            <p>
              The purpose is to help you with the challenges and stay motivated
            </p>

            <div className={styles.resources_devChallengesPanel_button}>
              <Button disabled aria-label="coming soon">
                Coming Soon
              </Button>
            </div>
          </Grid>

          <Grid item xs={12} sm={5}>
            <img
              loading="lazy"
              alt="DevChallenges"
              className={styles.resources_img}
              src="https://images.unsplash.com/photo-1543185377-99cd16011803?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80"
            ></img>
          </Grid>
        </Grid>
      </div>

      <h2 id="recommened-resources">Recommended Resources</h2>

      <div className={styles.resources_resource}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={5}>
            <img
              loading="lazy"
              className={styles.resources_img}
              alt="freecodecamp"
              src="https://camo.githubusercontent.com/60c67cf9ac2db30d478d21755289c423e1f985c6/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f66726565636f646563616d702f776964652d736f6369616c2d62616e6e65722e706e67"
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <div className={styles.resources_description}>
              <a
                href="https://www.freecodecamp.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2>freeCodeCamp</h2>
              </a>

              <p>
                <a
                  href="https://www.freecodecamp.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  freeCodeCamp
                </a>{" "}
                is a nonprofit community that helps you learn to code by
                building projects. It is 100% free.
              </p>
              <p>
                What I like about freeCodeCamp is the structure, it starts from
                the really basics to the most advanced and you learn by doing,
                similiarly with DevChallenges.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={styles.resources_resource}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={5}>
            <img
              loading="lazy"
              className={styles.resources_img}
              alt="Udemy"
              src="https://www.udemy.com/staticx/udemy/images/v6/default-meta-image.png"
            />
          </Grid>

          <Grid item xs={12} sm={7}>
            <div className={styles.resources_description}>
              <a
                href="https://www.udemy.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2>Udemy</h2>
              </a>
              <p>
                <a
                  href="https://www.udemy.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Udemy
                </a>{" "}
                is a online learning platform for adults and students. Well, I
                know that most of the cources cost money, but all the time they
                have discount for just 10 to 20 euros a courses, which in my
                opinons is a good price.
              </p>
              <p>
                As long as you find courses that has good reviews and with
                preview videos that you like. You can be confident that the
                course will be beneficial.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={styles.resources_resource}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={5}>
            <img
              loading="lazy"
              className={styles.resources_img}
              alt="The Net Ninja"
              src="https://firebasestorage.googleapis.com/v0/b/devchallenges-1234.appspot.com/o/Screen%20Shot%202020-05-19%20at%2011.03.16%20PM.png?alt=media&token=dc1abd58-584b-4df6-a6a2-4ecb19d567c7"
            />
          </Grid>

          <Grid item xs={12} sm={7}>
            <div className={styles.resources_description}>
              <a
                href="https://www.youtube.com/channel/UCW5YeuERMmlnqo4oq8vwUpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2>The Net Ninja - Youtube Channel</h2>
              </a>

              <p>
                <a
                  href="https://www.youtube.com/channel/UCW5YeuERMmlnqo4oq8vwUpg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Net Ninja
                </a>{" "}
                is my favorite youtube channel about web skills. This is the
                most structured coding channel on youtube and you can find
                almost everything about basic web skills, which is perfect to
                start with challenges.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Resources;
